export const CalSidebar = {
  extends: 'AppSidebar',

  Top: null,

  Middle: {
    padding: '0',
    CalMiniCalendar: {}
  },

  PeopleSection: {
    TeamGroup: { extends: 'PeopleGroup', label: 'TEAM', groupName: 'team' },
    AdvisorsGroup: {
      extends: 'PeopleGroup',
      label: 'ADVISORS',
      groupName: 'advisor',
      display: (el) => (el.call('currentUserIsSuperadmin') ? 'flex' : 'none')
    },
    InvestorsGroup: {
      extends: 'PeopleGroup',
      label: 'INVESTORS',
      groupName: 'investor',
      display: (el) => (el.call('currentUserIsSuperadmin') ? 'flex' : 'none')
    }
  }
}
